import { useState } from 'react';
import { Button, LinearProgress } from '@material-ui/core';
import {
  ConfigApi,
  configApiRef,
  IdentityApi,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';

export const WordToMD = () => {
  // const theme = useTheme();
  // const isDark = theme.palette.type === 'dark';
  const config = useApi<ConfigApi>(configApiRef);
  const identity = useApi<IdentityApi>(identityApiRef);
  const [inputFile, setInputFile] = useState<File | null>(null);
  const [downloadURL, setDownloadURL] = useState<string | null>(null);
  const [progress, setProgress] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [showConvert, setShowConvert] = useState<boolean>(false);
  const [convertedFileName, setConvertedFileName] = useState('output.md');

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setInputFile(event.target.files[0]);
      setDownloadURL(null);
      setProgress(0);
      setIsLoading(false);
      setShowConvert(true);
      event.target.value = '';
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const convertFile = async (inputFile: File | null) => {
    if (!inputFile) return;

    // Hide the convert button once conversion starts:
    setShowConvert(false);
    setIsLoading(true);
    setProgress(0);
    const progressInterval = setInterval(() => {
      setProgress(prev => (prev < 90 ? prev + 5 : prev));
    }, 500);

    const endpoint = inputFile.name.toLowerCase().endsWith('.docx')
      ? '/convert-docx'
      : '/convert-zip';
    const formData = new FormData();
    formData.append('file', inputFile);

    const backendHost = await config.getString('backend.baseUrl');
    const url = `${backendHost}/api/word-to-md${endpoint}`;

    const { token } = await identity.getCredentials();

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (response.ok) {
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        setDownloadURL(objectUrl);
        let filename = inputFile.name;
        if (endpoint.endsWith('/convert-docx')) {
          filename = inputFile.name.replace(/\.docx$/i, '.zip');
        }
        setConvertedFileName(filename);
      } else {
        clearInterval(progressInterval);
        setProgress(0);
        setIsLoading(false);
      }
    } catch (error) {
      clearInterval(progressInterval);
      setProgress(0);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  return (
    <div>
      <input
        accept=".docx,.zip"
        style={{ display: 'none' }}
        id="upload-file"
        type="file"
        onChange={handleFileUpload}
      />
      <label htmlFor="upload-file">
        <Button
          variant="contained"
          component="span"
          color="primary"
          style={{ marginBottom: 16 }}
        >
          Upload File(s)
        </Button>
      </label>
      {inputFile && showConvert && (
        <Button
          variant="contained"
          color="secondary"
          style={{ marginLeft: 16, marginBottom: 16 }}
          onClick={() => convertFile(inputFile)}
        >
          Convert to Markdown
        </Button>
      )}
      {isLoading && <LinearProgress variant="determinate" value={progress} />}
      {downloadURL && (
        <div style={{ marginTop: 16 }}>
          <a
            href={downloadURL}
            style={{ textDecoration: 'none' }}
            download={convertedFileName}
          >
            <Button variant="contained" color="primary">
              Download Markdown
            </Button>
          </a>
        </div>
      )}
    </div>
  );
};
